export default __webpack_public_path__ + "static/media/tailwind_yofte.b71afdc4.png";